module.exports = __webpack_public_path__ + "43087d4d23cb702bb4f279501fa22460.png";